import { useNewOrderFunnel } from "../utils/useNewOrderFunnel"
import {
  useGetDynamicOffersQuery,
  useGetRecentlyViewedOffersQuery,
} from "@apis/offers/useOffers"
import { OffersSummary } from "../OffersSummary"
import { OrderOnlineLink } from "../OrderOnlineLink"

export const ChooseOffer = () => {
  const { offersParams, shopper } = useNewOrderFunnel()

  const getDynamicOffersQuery = useGetDynamicOffersQuery(offersParams)
  const getRecentlyViewedOffersQuery = useGetRecentlyViewedOffersQuery(
    offersParams?.market_code,
    offersParams?.prospect_guid,
  )

  if (!offersParams) {
    return <div>Select from the filters on the left.</div>
  }

  if (getDynamicOffersQuery?.isError)
    return (
      <div className="tw:text-red-500">
        {`There was an error loading offers. Error: ${getDynamicOffersQuery?.error?.message}`}
      </div>
    )

  return (
    <div className="tw:flex tw:flex-col tw:gap-4">
      <div className="tw:flex tw:flex-col tw:gap-2">
        <OffersSummary
          title="Campaign Offers"
          data={getDynamicOffersQuery?.data?.eligible_offers || []}
          requestId={getDynamicOffersQuery?.data?.requestId}
          isPending={getDynamicOffersQuery?.isPending}
        />

        {getRecentlyViewedOffersQuery?.data && (
          <OffersSummary
            title="Recently Seen Offers"
            data={getRecentlyViewedOffersQuery.data}
            requestId={getRecentlyViewedOffersQuery.data?.requestId}
            isPending={getRecentlyViewedOffersQuery.isPending}
          />
        )}
        {shopper?.short_key && (
          <OrderOnlineLink shopper_short_key={shopper.short_key} />
        )}
      </div>
    </div>
  )
}
